import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { CLICKED_SHOW_ALL_ON_FILINGS_TIMELINE } from "constants/analyticsEvents";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { useAnalytics } from "hooks/useAnalytics";
import { TimelineFilingRow } from "store/apis/filingsTimeline";
import { getFilingShortName } from "utils/filingsTimeline/getFilingShortName";
import { getTimelineStatus } from "utils/filingsTimeline/getTimelineStatus";
import ToolTip from "components/design/toolTip";
import { useTimelineContext } from "./TimelineContext";
import { TimelineStatusDot } from "./TimelineStatusDot";

const TRIGGER_CLASS =
  "!t-h-[18px] !t-min-h-0 !t-px-1 !t-py-0 !t-text-[11px] !t-font-normal !t-leading-[16.5px] focus:!t-ring-0 focus-visible:!t-ring-2 focus-visible:!t-ring-purple-20";

const ROW_CLASS = "!t-px-3 !t-py-1.5 !t-text-body-sm-lite";

const DOT_CLASS = "t-h-2 t-w-2 !t-border-2";

const CONTENT_CLASS = "t-max-h-32 t-w-56";

const SIDE_OFFSET = 4;

type TimelineClusterDropdownProps = {
  filings: TimelineFilingRow[];
};

export const TimelineClusterDropdown = ({
  filings,
}: TimelineClusterDropdownProps) => {
  const { selectedRowKey, onSelectFiling } = useTimelineContext();
  const { trackEvent } = useAnalytics();

  const handleSelect = (filing: TimelineFilingRow) => () =>
    onSelectFiling(filing);

  const handleShowAllClick = () =>
    trackEvent(CLICKED_SHOW_ALL_ON_FILINGS_TIMELINE);

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <div>
          <Button
            customType="link"
            size="xxsmall"
            className={TRIGGER_CLASS}
            onClick={handleShowAllClick}
          >
            Show all
          </Button>
        </div>
      </Dropdown.Trigger>

      <Dropdown.Portal>
        <Dropdown.Content
          side="top"
          align="center"
          sideOffset={SIDE_OFFSET}
          className={CONTENT_CLASS}
        >
          {filings.map((filing) => (
            <Dropdown.Item
              key={filing.rowKey}
              onSelect={handleSelect(filing)}
              icon={
                <TimelineStatusDot
                  status={getTimelineStatus(filing)}
                  className={DOT_CLASS}
                />
              }
              className={classNames(
                ROW_CLASS,
                filing.rowKey === selectedRowKey
                  ? "!t-bg-purple-0 !t-text-purple"
                  : "!t-text-text-100"
              )}
            >
              <ToolTip text={filing.name} disableHoverableContent>
                <span className="t-block t-min-w-0 t-truncate t-text-left">
                  {getFilingShortName(filing)}
                </span>
              </ToolTip>
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
